var map = {
	"./thumbnail_awards_2021.png": 83,
	"./thumbnail_awards_2022.png": 84,
	"./thumbnail_awards_2023.png": 85,
	"./thumbnail_de.png": 86,
	"./thumbnail_en.png": 87,
	"./thumbnail_es.png": 88,
	"./thumbnail_fr.png": 89,
	"./thumbnail_ru.png": 90,
	"./thumbnail_uk.png": 91,
	"./thumbnail_zh-CN.png": 92,
	"./thumbnail_zh-TW.png": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;